import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../common/baseComponent/base.component';
import { ErrorFieldGroup, ERRORTYPE } from './form.objects';

@Component({
  selector: 'plyca-error-counter',
  templateUrl: 'error.counter.template.html'
})
export class ErrorCounterComponent extends BaseComponent {

  @Input()
  errorGroup: ErrorFieldGroup;
  @Input()
  displayShowButton = false;
  @Input()
  hidden = false;
  @Output()
  showEvent = new EventEmitter();

  public showErrors = false;
  public ERRORTYPE = ERRORTYPE;

  public emmitShowEvent(): void {
    if (this.errorGroup.numberOfErrors() > 0) {
      this.showErrors = !this.showErrors;
      this.showEvent.emit(this.showErrors);
      this.hidden = false;
    }
  }
  close() {
    this.hidden = true;
  }

  ngOnDestroy(): void {
    delete this.errorGroup;
    super.ngOnDestroy();
  }
}
